// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1707":"36b56bf8","3002":"36b56bf8","6206":"36b56bf8","7044":"36b56bf8"}[chunkId] + ".chunk.css";
};